import createReducer, { ActionCreatorHelper } from '@hh.ru/redux-create-reducer';

import { resetPage } from 'src/components/ReportFilters/utils';
import Filter, { FilterType } from 'src/constants/filter';
import Report from 'src/constants/report';

export interface FilterValues {
    common: {
        [Filter.StartDate]: FilterType[Filter.StartDate];
        [Filter.EndDate]: FilterType[Filter.EndDate];
        [Filter.Date]: FilterType[Filter.Date];
        [Filter.Managers]: FilterType[Filter.Managers];
        [Filter.Areas]: FilterType[Filter.Areas];
        [Filter.Population]: FilterType[Filter.Population];
        [Filter.ProfRoles]: FilterType[Filter.ProfRoles];
        [Filter.PublicationTypes]: FilterType[Filter.PublicationTypes];
        [Filter.Page]: FilterType[Filter.Page];
        [Filter.SalaryRange]: FilterType[Filter.SalaryRange];
        [Filter.WorkExperience]: FilterType[Filter.WorkExperience];
        [Filter.CompetitionLevel]: FilterType[Filter.CompetitionLevel];
    };
    [Report.Managers]: {
        [Filter.Page]: FilterType[Filter.Page];
        [Filter.SortBy]: FilterType[Filter.SortBy];
    };
    [Report.Vacancies]: {
        [Filter.ShowVacancies]: FilterType[Filter.ShowVacancies];
        [Filter.Page]: FilterType[Filter.Page];
        [Filter.SortBy]: FilterType[Filter.SortBy];
    };
    [Report.PolitenessIndexByManagers]: {
        [Filter.Page]: FilterType[Filter.Page];
    };
    [Report.BrandedVacancies]: {
        [Filter.Stage]: FilterType[Filter.Stage];
        [Filter.VacancyBrandedTemplates]: FilterType[Filter.VacancyBrandedTemplates];
        [Filter.Vacancy]: FilterType[Filter.Vacancy];
    };
    [Report.CallTracking]: {
        [Filter.Page]: FilterType[Filter.Page];
    };
    [Report.VacancyConversion]: {
        [Filter.StartDate]: FilterType[Filter.StartDate];
        [Filter.EndDate]: FilterType[Filter.EndDate];
        [Filter.Vacancy]: FilterType[Filter.Vacancy];
    };
}

const initialState = {} as FilterValues;

const SET_FILTER_VALUES = 'SET_FILTER_VALUES';

// TODO Данный тип не умеет определять точный тип для значения фильтра.
//  Например, если у отчета Report.Managers могут быть два фильтра Filter.Page и Filter.SortBy, то тип для value будет number | string.
export type SetFilterValuesPayload<FV = FilterValues, R = keyof FV> = R extends keyof FV
    ? { reportName?: R; filterName: keyof FV[R]; value: FV[R][keyof FV[R]] }
    : never;

interface PayloadTypes {
    [SET_FILTER_VALUES]: SetFilterValuesPayload;
}

const actionCreator = ActionCreatorHelper<PayloadTypes>();
export const setFilterValue = actionCreator(SET_FILTER_VALUES);

export default createReducer<FilterValues, PayloadTypes>(initialState, {
    [SET_FILTER_VALUES]: (state, { payload }) => {
        const { reportName = 'common', filterName, value } = payload;
        const newState: FilterValues = {
            ...state,
            [reportName]: {
                ...state[reportName],
                [filterName]: value,
            },
        };

        resetPage(newState, filterName);
        return newState;
    },
});
